import {
    ApiRecommendationsByPlacementSuccessResponse,
} from '@shared/product/related-products/domain/models/recommendations-by-placement.model';
import {
    ProductUid,
    RelatedProductType,
    RelatedsProvider,
} from '@shared/product/related-products/domain/models/related-products.models';

export const recommendationsByPlacementTransformer = (
    response: ApiRecommendationsByPlacementSuccessResponse,
    type: string,
): ProductUid[] => {
    if (response.emptyResponse) return [];
    return response.recommendations.reduce((acc: ProductUid[], respObject) => {
        const mcc = respObject.reference.split('-')[0];
        acc.push({
            colorId: mcc.slice(-3),
            product_id: respObject.id.toString(),
            provider: respObject.metadata.provider as RelatedsProvider,
            relatedType: type as RelatedProductType,
            uid: mcc.slice(0, -3).padStart(8, '0'),
        });
        return acc;
    }, []);
};
